<template>
    <div>
        <security-questions
            ref="refSecurityQuestions"
            :user-profile-id="userProfileId"
            :user-profiles-data="userProfilesData"
        />
        <div class="align-center-bottom">
            <ejs-button
                type="button"
                cssClass="e-info margin-button"
                v-on:click.native="onSubmitSecurityQuestionClick(false)"
                >Save Security Questions
            </ejs-button>
        </div>
    </div>
</template>

<script>
import Vue from "vue";

import { ButtonPlugin } from "@syncfusion/ej2-vue-buttons";
import SecurityQuestions from "./security-questions.vue";

Vue.use(ButtonPlugin);
export default {
  name: "ManageCustomer",
  components: {
    SecurityQuestions,
  },
  props: {
    userProfileId: String,
    userProfilesData: Object,
  },
  data() {
    return {

    };
  },
  methods: {
    onSubmitSecurityQuestionClick(hideNofificationMessage = false) {
      // this.$parent.notificationToasts.length = 0;
      const securityQuestion = this.$refs.refSecurityQuestions;
      const inValidFields = [];
      let notificationContent = null;

      const { isSecurityAnswerOne } = securityQuestion;
      const { isSecurityAnswerTwo } = securityQuestion;
      const { isSecurityAnswerThree } = securityQuestion;
      const { isConfirmAnswerOne } = securityQuestion;
      const { isConfirmAnswerTwo } = securityQuestion;
      const { isConfirmAnswerThree } = securityQuestion;

      const isFormValid = isSecurityAnswerOne
        && isSecurityAnswerTwo
        && isSecurityAnswerThree
        // && securityQuestion.ddlSecurityQuestionOne !== null
        && isConfirmAnswerOne
        && isConfirmAnswerTwo
        && isConfirmAnswerThree;
      // && securityQuestion.ddlSecurityQuestionTwo !== null
      // && securityQuestion.ddlSecurityQuestionThree !== null;

      if (!isSecurityAnswerOne || !isConfirmAnswerOne) {
        inValidFields.push("Answer 1");
      }
      if (!isSecurityAnswerTwo || !isConfirmAnswerTwo) {
        inValidFields.push("Answer 2");
      }
      if (!isSecurityAnswerThree || !isConfirmAnswerThree) {
        inValidFields.push("Answer 3");
      }

      if (isFormValid) {
        securityQuestion.securityQuestions();
        if (!hideNofificationMessage) {
          notificationContent = "Security questions updated successfully.";
        }
      } else {
        securityQuestion.validateSecurityQuestions();
        notificationContent = `Please enter value in required fields.<br><ul><li>${inValidFields.join(
          "</li><li>",
        )}</li></ul>`;
      }
      if (notificationContent) {
        this.showNotification(inValidFields, notificationContent);
      }
      return isFormValid;
    },
    showNotification(invalidFields, content) {
      const parent = this.$parent.$parent;
      const notificationObj = {
        content,
        timeOut: 5000,
      };
      if (invalidFields.length === 0) {
        notificationObj.cssClass = "e-toast-success";
        notificationObj.title = "Success!";
      } else {
        notificationObj.cssClass = "e-toast-danger";
        notificationObj.title = "Error!";
      }
      parent.notificationToasts.push(notificationObj);
      parent.$refs.notifierRef.show();
    },
  },
};
</script>
